import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Prices from '@/components/Prices'
import Cars from '@/components/Cars'
import Booking from '@/components/Booking'
import Contacts from '@/components/Contacts'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/prices',
      name: 'Prices',
      component: Prices
    },
    {
      path: '/cars',
      name: 'Cars',
      component: Cars
    },
    {
      path: '/booking',
      name: 'Booking',
      component: Booking
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: Contacts
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js